"use client";
import Link from "next/link";
import { ArrowRight, Calendar, FileCheck, Lock } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { consultation as data } from "@/lib/data/contact";

const accent = "var(--color-purple)";

export function Consultation() {
  return (
    <Section id="consultation-booking" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Calendar className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Consultation Types</span>
              </div>
              <div className="mt-4 space-y-3">
                {data.types.map((t) => (
                  <div key={t.name} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{t.name}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{t.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <FileCheck className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Booking Process</span>
              </div>
              <div className="mt-4 space-y-2">
                {data.process.map((p) => (
                  <div key={p.step} className="text-sm">
                    <span className="font-semibold" style={{ color: accent }}>{p.step}.</span> {p.title}{p.body ? <span className="text-[rgb(var(--fg-muted))]"> — {p.body}</span> : null}
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
        <div className="mt-5 grid sm:grid-cols-2 gap-5">
          <Reveal delay={200}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <Lock className="h-4 w-4" style={{ color: accent }} />
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.confidentiality.title}</span>
              </div>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.confidentiality.body}</p>
            </div>
          </Reveal>
          <Reveal delay={250}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.post.title}</span>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.post.body}</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={400}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
